import { render, staticRenderFns } from "./authorizationRecordList.vue?vue&type=template&id=6e81583c&scoped=true"
import script from "./authorizationRecordList.vue?vue&type=script&lang=js"
export * from "./authorizationRecordList.vue?vue&type=script&lang=js"
import style0 from "./authorizationRecordList.vue?vue&type=style&index=0&id=6e81583c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81583c",
  null
  
)

export default component.exports